var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49302 16.1271C6.33575 16.1263 6.18235 16.0782 6.05284 15.989C5.92332 15.8998 5.8237 15.7736 5.76696 15.6269C5.71023 15.4802 5.69901 15.3198 5.73478 15.1667C5.77055 15.0135 5.85164 14.8747 5.96748 14.7683L11.7742 9.49261L5.96748 4.20987C5.88803 4.14188 5.82305 4.05862 5.77639 3.96503C5.72972 3.87144 5.70233 3.76944 5.69584 3.66507C5.68935 3.56069 5.70389 3.45608 5.73859 3.35743C5.7733 3.25878 5.82746 3.16811 5.89787 3.0908C5.96829 3.01348 6.05351 2.95109 6.14849 2.90734C6.24347 2.86358 6.34627 2.83935 6.45079 2.83608C6.55532 2.8328 6.65943 2.85056 6.75696 2.88829C6.8545 2.92602 6.94346 2.98295 7.01857 3.05571L13.4602 8.91553C13.5406 8.98872 13.6048 9.07789 13.6487 9.17732C13.6927 9.27676 13.7154 9.38429 13.7154 9.493C13.7154 9.60172 13.6927 9.70924 13.6487 9.80868C13.6048 9.90812 13.5406 9.99729 13.4602 10.0705L7.01857 15.924C6.86785 16.0599 6.68044 16.1271 6.49302 16.1271Z",
    fill: "#272A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.5c2c29c700cf8c584d58e484cc842861.svg";
export { ForwardRef as ReactComponent };